<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs4>
        <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
          <v-card class="elevation-2">
            <v-toolbar class="elevation-0" dense dark color="teal">
              <v-toolbar-title>Login form</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <ValidationProvider name="login" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="login"
                  prepend-icon="mdi-account-circle"
                  label="Login"
                  type="text"
                  color="teal"
                  :error-messages="errors[0]"
                  @keyup.enter="handleSubmit(loginMethod)"
                />
              </ValidationProvider>
              <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="password"
                  id="password"
                  prepend-icon="mdi-lock"
                  label="Password"
                  type="password"
                  color="teal"
                  :error-messages="errors[0]"
                  @keyup.enter="handleSubmit(loginMethod)"
                />
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                @click="handleSubmit(loginMethod)"
                color="teal"
                dark
              >
                Login
              </v-btn>
            </v-card-actions>
          </v-card>
        </ValidationObserver>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      login: '',
      password: '',
    }
  },
  methods: {
    async loginMethod() {
      try {
        const { data } =  await this.$axios.post('/api/login', {
          hash: Buffer.from(this.login + '-frog-' + this.password, 'ascii')
        });
        await this.$store.dispatch('login', data)
        this.$nextTick(() => {
          this.$router.push('/')
        })
      } catch (error) {
        const message = error.response && error.response.data || null
        if (message && /(login)/.test(message)) {
          this.$refs.obs.setErrors({
            login: [message]
          })
        } else if (message !== null) {
          this.$refs.obs.setErrors({
            password: [message]
          })
        }
      }
    }
  }
}
</script>